import React from 'react';
import Header from './Header';
import Footer from './Footer';
import HeroImage from '../../images/hero-image.png';
import ExploreImage from '../../images/explore-image.png';
import DeployImage from '../../images/deploy-image.png';
import SignupImage from '../../images/signup-image.png';
import Netflix from '../../images/netflix.png';
import Nike from '../../images/nike.png';
import Slack from '../../images/slack.png';
import Microsoft from '../../images/microsoft.png';
import Shopify from '../../images/shopify.png';
import Intel from '../../images/intel.png';
import RadialBG from '../../images/radial.png';
import Dots from '../../images/dots.png';
import CRLogo from '../../images/CR.svg';
import CHLogo from '../../images/chLogo.png';
import CCImage from '../../images/cc.jpeg';
import EsImage from '../../images/es.png';
import './index.css';

import {
  AdaptationIcon,
  ArrowIcon,
  ChatIcon,
  CheckIcon,
  CloudIcon,
  CreditCardIcon,
  DataIcon,
  DeleteIcon,
  FastIcon,
  HostIcon,
  KeywordIcon,
  LocationIcon,
  QuoteMark,
  ServerIcon,
} from './Icons';
import { appUrl } from '../../utils/routing';

function Homepage() {
  return (
    <div className="position-relative">
      <Header />
      <div>
        <section className="hero container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <h1 className="mb-4">
                Boost Remote Team
                {' '}
                <span className="orange">Productivity</span>
                {' '}
                with Secure Time Tracking
              </h1>
              <p className="mb-3">
                Enhanced employee engagement with robust security,
                seamless background time-tracking, and team and individual productivity reporting.
                Shoot is your ultimate tool for managing remote teams efficiently and effectively.
              </p>
              <div className="d-flex align-items-center py-4 flex-wrap">
                <a className="btn btn-primary" href={`${appUrl()}organization-signup`}>Sign Up</a>
                <a className="btn btn-link d-none d-md-flex" href="/">
                  Explore Service
                  <ArrowIcon className="ms-2" width="18" height="18" />
                </a>
              </div>
              <div className="info billing-info d-flex flex-wrap mb-4 mb-md-0 flex-column flex-lg-row">
                <span className="d-flex align-items-center me-2 mb-2 mb-lg-0">
                  <CheckIcon className="me-1" width="20" height="20" />
                  Get 14 days free trial
                </span>
                <span className="d-flex align-items-center me-2 mb-2 mb-lg-0">
                  <CheckIcon className="me-1" width="20" height="20" />
                  No credit card is required
                </span>
                <span className="d-flex align-items-center me-2 mb-2 mb-lg-0">
                  <CheckIcon className="me-1" width="20" height="20" />
                  Cancel anytime
                </span>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <img className="hero-image" src={HeroImage} alt="Hero" width="525" height="530" loading="lazy" />
            </div>
          </div>
        </section>
        <section className="partners container">
          <img src={Netflix} alt="Netflix" />
          <img src={Nike} alt="Nike" />
          <img src={Slack} alt="Slack" />
          <img src={Microsoft} alt="Microsoft" />
          <img src={Shopify} alt="Shopify" />
          <img src={Intel} alt="Intel" />
        </section>
        <section className="signup container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <h2 className="mb-3">
                Get Started with Shoot Today and Transform Your Remote Team Management!
              </h2>
              <p className="mb-4">
                Transform the way you manage remote teams with Shoot
                – your go-to solution for efficient and effective remote team management. Sign up now!
              </p>
              <div className="info">
                <h6 className="mb-3">This 14-day free trial includes features like:</h6>
                <span className="info-item d-flex mb-3">
                  <CheckIcon className="me-2" width="20" height="20" />
                  Desktop time tracking app with automated screenshot and webcam monitoring.
                </span>
                <span className="info-item d-flex mb-3">
                  <CheckIcon className="me-2" width="20" height="20" />
                  Team management with role-based access control and custom permissions.
                </span>
                <span className="info-item d-flex mb-3">
                  <CheckIcon className="me-2" width="20" height="20" />
                  Comprehensive timesheets, activity logs, and geo dashboard for location tracking.
                </span>
                <span className="info-item d-flex mb-3">
                  <CheckIcon className="me-2" width="20" height="20" />
                  Advanced insider threat detection with robot and bot behavior monitoring.
                </span>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex">
              <img
                className="ms-auto hero-image"
                src={SignupImage}
                alt="Hero"
                width="510"
                height="604"
                loading="lazy"
              />
            </div>
          </div>
        </section>
        <section className="features container">
          <div className="d-flex flex-column align-items-center text-center mb-4">
            <h2 className="mb-3">
              Comprehensive Features for Remote Team Management
            </h2>
            <p>Time Tracking, Security Monitoring, and Advanced Team Management</p>
          </div>
          <div className="row py-3">
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <FastIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Desktop Time Tracking</h6>
                <p className="info">
                  Automated time tracking with our desktop app that runs discreetly in the background.
                  Includes timesheets, screenshots, webcam audit, and comprehensive reporting.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column shadow">
                <LocationIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Geo Dashboard & Location Tracking</h6>
                <p className="info">
                  Real-time location monitoring and geographic team distribution insights.
                  Track where your remote team is working from with our geo dashboard.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <DeleteIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Insider Threat Detection</h6>
                <p className="info">
                  Advanced robot detection prevents fraud with automated bot detection,
                  mouse jiggler identification, and suspicious activity alerts to protect your business.
                </p>
              </div>
            </div>
          </div>
          <div className="row py-3">
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <CloudIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Role-Based Access Control</h6>
                <p className="info">
                  Granular permissions with custom roles and access levels.
                  Manage team hierarchy with 6 system roles and unlimited custom roles.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <CheckIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Time Off & PTO Management</h6>
                <p className="info">
                  Track vacation requests, approve time off, and manage paid time off seamlessly.
                  Integrated with timesheets for accurate reporting.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <DataIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Team Engagement Analytics</h6>
                <p className="info">
                  Monitor team productivity with engagement metrics, activity logs,
                  and comprehensive reports to optimize team performance.
                </p>
              </div>
            </div>
          </div>
          <div className="row py-3">
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <KeywordIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Enterprise Authentication</h6>
                <p className="info">
                  Multiple 2FA options including email, Google Authenticator, and SAML SSO.
                  Integrate with Okta, Azure AD, and Google Workspace.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <ServerIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Scheduled Email Reports</h6>
                <p className="info">
                  Automated email reports on schedule, custom notifications,
                  and real-time alerts for critical events and security incidents.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="features-item d-flex flex-column">
                <ChatIcon className="mb-3" width="40" height="40" />
                <h6 className="mb-2">Comprehensive Support</h6>
                <p className="info">
                  Access our help center, live chat support (24/7 for enterprise),
                  and email support with 24x5 SLA for business customers.
                </p>
              </div>
            </div>
          </div>
          <a
            href={`${appUrl()}organization-signup`}
            className="btn btn-primary mx-auto mt-4 d-none d-md-flex"
          >
            Get Started
          </a>
        </section>
        <section className="testimonial">
          <div className="container position-realative">
            <QuoteMark width="142" height="116" className="quote-mark position-absolute" />
            <div className="row">
              <div className="col-12 col-md-6">
                <h2 className="mb-2">Real Stories from Real Customers</h2>
                <p className="mb-4 pb-3">Get inspired by these stories.</p>
                <div className="testimonial-card ms-auto mb-4 testimonial-card-1">
                  <img
                    className="me-3"
                    src={CRLogo}
                    alt="Chris Carter"
                    style={{ width: '200px', objectFit: 'cover' }}
                  />
                  <div className="testimonial-info d-flex">
                    <QuoteMark className="me-3" width="16" height="13" />
                    <p className="w-0">
                      {`Shoot transformed our operations overnight. With real-time productivity insights
                      and seamless time tracking, we've seen a 40% increase in team efficiency.
                      The geo-dashboard helps us coordinate our distributed workforce perfectly,
                      and the insider threat detection gives us peace of mind. This platform turned
                      data into action and elevated our entire organization.`}
                    </p>
                  </div>
                  <div className="testimonial-writer d-flex align-items-center">
                    <img
                      className="me-3 rounded-circle"
                      src={EsImage}
                      alt="Chris Carter"
                      style={{ width: '85px', height: '85px', objectFit: 'cover' }}
                    />
                    <div className="d-flex flex-column">
                      <h6>Everett Steele</h6>
                      <p>Senior Vice President - Operations</p>
                      <p>Chart Request</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="testimonial-card testimonial-card-2 mb-4">
                  <img
                    className="me-3"
                    src={CHLogo}
                    alt="Chris Carter"
                    style={{ width: '200px', objectFit: 'cover' }}
                  />
                  <div className="testimonial-info d-flex">
                    <QuoteMark className="me-3" width="16" height="13" />
                    <p className="w-0">
                      {`Building a healthcare company requires trust and transparency. Shoot delivers both.
                      Our remote medical team stays connected and accountable through intuitive time tracking
                      and activity logs. The RBAC system ensures HIPAA compliance, while engagement analytics
                      help us nurture our team's wellbeing. It's not just software—it's the foundation of
                      our productive, healthy workplace culture.`}
                    </p>
                  </div>
                  <div className="testimonial-writer d-flex align-items-center">
                    <img
                      className="me-3 rounded-circle"
                      src={CCImage}
                      alt="Chris Carter"
                      style={{ width: '85px', height: '85px', objectFit: 'cover' }}
                    />
                    <div className="d-flex flex-column">
                      <h6>Chris Carter</h6>
                      <p>Founder & Executive Chairman</p>
                      <p>Carabao Health</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="explore container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 d-none d-md-flex">
              <img className="hero-image" src={ExploreImage} alt="Hero" width="570" height="533" loading="lazy" />
            </div>
            <div className="col-12 col-md-6">
              <h2 className="mb-3">Explore Shoot with Confidence</h2>
              <p className="mb-4">
                Discover all features risk-free and get acquainted with our platform before making a commitment.
              </p>
              <div className="d-flex d-md-none">
                <img
                  className="hero-image"
                  src={ExploreImage}
                  alt="Hero"
                  width="570"
                  height="533"
                  loading="lazy"
                />
              </div>
              <h6 className="mb-3">Start Your Free 14-Day Trial</h6>
              <span className="d-flex info info-item mb-3">
                <CreditCardIcon className="me-2" width="20" height="20" />
                No credit card is required
              </span>
              <span className="d-flex info info-item mb-4">
                <KeywordIcon className="me-2" width="20" height="20" />
                Enjoy full access to all the features Shoot has to offer.
              </span>
              <h6 className="mb-3">Explore in a Safe Environment</h6>
              <span className="d-flex info info-item mb-3">
                <DataIcon className="me-2" width="20" height="20" />
                Use our demo data to explore and test all features.
              </span>
              <span className="d-flex info info-item mb-4">
                <ServerIcon className="me-2" width="20" height="20" />
                Secure and hosted environment designed for easy exploration.
              </span>
            </div>
          </div>
        </section>
        <section className="deploy container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <h2 className="mb-3">Deploy and Customize Your Solution</h2>
              <p className="mb-4">
                Transition smoothly from exploration to a tailored,
                fully-hosted deployment that meets your specific needs.
              </p>
              <div className="d-flex d-md-none">
                <img
                  className="hero-image"
                  src={DeployImage}
                  alt="Hero"
                  width="570"
                  height="537"
                  loading="lazy"
                />
              </div>
              <h6 className="mb-3">Deploy Your Own Solution</h6>
              <span className="d-flex info info-item mb-3">
                <DeleteIcon className="me-2" width="20" height="20" />
                Once ready, delete all dummy data with a few clicks.
              </span>
              <span className="d-flex info info-item mb-4">
                <AdaptationIcon className="me-2" width="20" height="20" />
                Deploy your own hosted solution seamlessly.
              </span>
              <h6 className="mb-3">Explore in a Safe Environment</h6>
              <span className="d-flex info info-item mb-3">
                <HostIcon className="me-2" width="20" height="20" />
                Prefer to host in your own environment? No problem!
              </span>
              <span className="d-flex info info-item mb-4">
                <CloudIcon className="me-2" width="20" height="20" />
                Shoot easily deploys to Google Cloud, AWS, and colo environments.
              </span>
            </div>
            <div className="col-12 col-md-6 d-none d-md-flex">
              <img className="hero-image" src={DeployImage} alt="Hero" width="570" height="537" loading="lazy" />
            </div>
          </div>
        </section>
        <section className="start position-relative">
          <img className="background" src={RadialBG} alt="background" />
          <img className="dots position-absolute top-left" src={Dots} alt="dots" />
          <img className="dots position-absolute bottom-right" src={Dots} alt="dots" />
          <div className="container position-relative text-center d-flex align-items-center flex-column">
            <h2 className="mb-2">Start Your Free Trial and Streamline Your Workflow!</h2>
            <p className="mb-4 pb-3">
              Sign up today to access Shoot’s powerful features and give
              your team the tools they need to excel. Experience the full
              potential of our platform risk-free and start optimizing your processes with ease.
            </p>
            <a className="btn btn-primary" href={`${appUrl()}organization-signup`}>Get Started</a>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Homepage;
